import { PredefinedPackage } from 'app/models/predefinedPackageModel'

export const getPredefinedPackageName = (
  predefinedPackage: PredefinedPackage,
  translate: (string) => string,
): string => {
  const text: string = PredefinedPackage[predefinedPackage]
  return translate(`predefinedPackage.${text}`)
}
